class BundleInclusions extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.selectionsElement = this.querySelector('[name="properties[_bundle_selections]"]');
    this.accordionElements = this.querySelectorAll(".bundle-inclusions__accordion");
    this.addEventListener("change", this.handleChange);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.handleChange);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    if (window.innerWidth >= 700) {
      for (const el of this.accordionElements) {
        el.open = true;
        el.setAttribute("aria-expanded", "true");
      }
    }
  }

  handleChange(e) {
    const fieldset = e.target.closest("[data-product-index]");
    if (!fieldset) return;
    const slotIndex = Number(fieldset.dataset.productIndex);

    const selections = this.selectionsElement.value.split(",");
    this.selectionsElement.value = selections
      .map((id, i) => (i === slotIndex ? e.target.dataset.variantId : id))
      .join(",");

    const labelEl = fieldset.querySelector("[data-swatch-selected-value]");
    if (labelEl && e.target.nextElementSibling) {
      labelEl.textContent = e.target.nextElementSibling.textContent;
    }

    this.swapImage(e.target);
  }

  swapImage(swatchInput) {
    const mediaJson = swatchInput.dataset.variantMedia;
    if (!mediaJson) return;

    const row = swatchInput.closest(".horizontal-product");
    const img = row && row.querySelector(".horizontal-product__image");
    if (!img) return;

    let media;
    try {
      media = JSON.parse(mediaJson);
    } catch {
      return;
    }
    if (!media || !media.src) return;

    const existingSrcset = img.getAttribute("srcset") || "";
    const widths = [...existingSrcset.matchAll(/(\d+)w/g)].map((m) => Number(m[1]));

    const buildUrl = (w) => {
      try {
        const u = new URL(media.src, window.location.origin);
        u.searchParams.set("width", String(w));
        return u.toString();
      } catch {
        return media.src;
      }
    };

    if (widths.length) {
      img.srcset = widths.map((w) => `${buildUrl(w)} ${w}w`).join(", ");
      img.src = buildUrl(widths[0]);
    } else {
      img.src = media.src;
    }
    if (media.alt) img.alt = media.alt;
  }
}

customElements.define("bundle-inclusions", BundleInclusions);
